import { render, staticRenderFns } from "./HackathonDetail.vue?vue&type=template&id=5bf3b61f&"
import script from "./HackathonDetail.vue?vue&type=script&lang=js&"
export * from "./HackathonDetail.vue?vue&type=script&lang=js&"
import style0 from "./HackathonDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports